import { ContractFilter } from '@ph-model/filters/contract-filter.model';
import { Filter } from '@ph-model/filters/filter';

export class SearchFilter {
  constructor(
    public month: ContractFilter[] = [],
    public status: Filter[] = [],
    public productCode: Filter[] = [],
    public productType: Filter[] = [],
    public searchPhrase: string = '',
  ) {}
}
